import MainLayout from "components/layout/main-layout/MainLayout";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import "./DeviceProfile.css";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import {
  ArrowRight,
  IconEdit,
  IconGPSDevice,
  IconQuestion,
  IconTracking,
} from "assets/SVGs/SVGs";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef, useCallback } from "react";
import moment from "moment";
import DeviceInfoModal from "components/layout/device-info-modal/DeviceInfoModal";
import EditDeviceNameModal from "components/layout/edit-device-name-modal/EditDeviceNameModal";
import AddStepGoalModal from "components/layout/add-step-goal-modal/AddStepGoalModal";
import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import ChangesSavedModal from "components/layout/changes-saved-modal/ChangesSavedModal";
import RingDeviceModal from "components/layout/ring-device-modal/RingDeviceModal";
import CaregiverTrackingCard from "components/layout/caregiver-tracking-card/CaregiverTrackingCard";
import StepCounterCard from "components/layout/step-counter-card/StepCounterCard";
import {
  convertInRequiredTimeZone,
  getLastRefreshTimeInMinutes,
  getManualRefreshTime,
  getStaticUrlByKey,
  isDisableManualRefresh,
  isEmpty,
} from "utility";
import {
  getAneltoTimeline,
  getClairvoyantTimeline,
  getEviewTimeLine,
  getFreeusTimeline,
  ringMyDevice,
  setDeviceDetailLoaderVisibility,
  getDeviceDetails,
  callSycsDevideDetails,
  setDeviceSyncLog,
  callDeviceSynLogs,
  getDeviceStatus,
  resetDeviceStatus,
} from "redux/Devices/actions";
import { getAppConfigurations } from "redux/Common/action";
import { useDispatch, useSelector } from "react-redux";
import { loader_gif } from "assets/images/images";
import {
  eventLogs,
  getCalculatedLastRefreshTime,
} from "../../utility/deviceDetailUtils";
import InformationModal from "components/layout/information-modal/InformationModal";
import DeviceSignalCard from "components/layout/device-signal-card/DeviceSignalCard";
import FrequentRequestPopup from "components/layout/frequent-request-popup/FrequentRequestPopup";
import { useDeviceSyncStatus } from "hooks/useDeviceSyncStatus";
import { useDeviceSocket } from "hooks/useDeviceSocket";
import { SYNC_STATUS } from "constants/syncStatus";

const DeviceProfile = () => {
  const [showDeviceInfo, setShowDeviceInfo] = useState(false);
  const [showEditDeviceModal, setShowEditDeviceModal] = useState(false);
  const [showAddStepGoalModal, setShowAddStepGoalModal] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showSavedSuccessModal, setShowSavedSuccessModal] = useState(false);
  const [showRingDeviceModal, setShowRingDeviceModal] = useState(false);
  const [informationModal, setInformationModal] = useState(false);
  const [frequentRequestPopup, setFrequentRequestPopup] = useState({
    data: null,
    isVisible: false,
  });
  const history = useHistory();

  const { onApiResponse, snackbarState, dismissSnackbar } =
    useAdvancedValidation();

  const accordianButtons = [
    {
      name: titles?.device_signal_history,
      onClick: () => history.push(ROUTES_CONSTANTS?.deviceSignalHistory),
    },
    {
      name: titles?.get_user_help_guide,
      onClick: () => onUserHelpGuide(),
    },
    {
      name: titles?.device_sync_history_title,
      onClick: () => history.push(ROUTES_CONSTANTS?.deviceSyncHistory),
    },
  ];

  const [deviceLocation, setDeviceLocation] = useState({
    latitude: null,
    longitude: null,
    latitudeDelta: 0.008,
    longitudeDelta: 0.008,
  });

  const [disableManualRefresh, setDisableManualRefresh] = useState(false);
  const [manualRefreshIntervalTime, setManualRefreshIntervalTime] = useState(0);
  const prevDisableStateRef = useRef(null);
  const deviceStatusTimeoutRef = useRef(null);
  const scheduleNextDeviceStatusRefreshRef = useRef(null);

  const userData = useSelector((store) => store?.auth?.userData);
  const {
    selectedDeviceDetails,
    loading,
    freeusIntervals,
    aneltoIntervals,
    clairvoyantIntervals,
    deviceDetailLoading,
    eViewIntervalArray,
    manualRefreshLoading,
    deviceDetails,
    deviceSyncLogs,
    deviceSyncData,
    deviceStatus,
  } = useSelector((store) => store?.devices);
  const { staticUrls, currentTimeZone, appConfigurations } = useSelector(
    (store) => store?.common
  );
  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const dispatch = useDispatch();
  const isInHomDevice = isEmpty(selectedDeviceDetails?.device_type);

  const { buttonText, isSyncing, isSyncExpired } = useDeviceSyncStatus(
    deviceDetails,
    titles?.refresh_signal
  );

  const prevIsSyncExpiredRef = useRef(false);

  const deviceSyncLogsRef = useRef(deviceSyncLogs);
  const syncRef = useRef(deviceSyncData);

  useEffect(() => {
    deviceSyncLogsRef.current = deviceSyncLogs;
    syncRef.current = deviceSyncData?.syncId;
  }, [deviceSyncLogs, deviceSyncData]);

  useEffect(() => {
    resetDeviceStatus(dispatch);

    if (!isInHomDevice) {
      setDeviceSyncLog(dispatch, {
        log: eventLogs?.enter_device_screen,
        loggedAt: moment()?.utc()?.toISOString(),
      });
      const param = {
        dispatch,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      };
      getAppConfigurations(param);
      getAneltoTimeline(param);
      getFreeusTimeline(param);
      getClairvoyantTimeline(param);
      getEviewTimeLine(param);
      getDeviceProfileDetail();
      fetchDeviceStatus();  
    }
    return () => {
      cleanUpCall();
    };
  }, [selectedDeviceDetails?.user_device_id]);

  const fetchDeviceStatus = useCallback(() => {
    if (
      selectedDeviceDetails?.user_device_id &&
      selectedDeviceDetails?.device_type?.trim()?.toLowerCase() !== "clairvoyant" &&
      !isInHomDevice
    ) {
      getDeviceStatus(
        dispatch,
        { userDeviceId: selectedDeviceDetails?.user_device_id },
        userData?.isGuestUser ? "guestuser" : "accountowner",
        history
      );
    }
  }, [
    selectedDeviceDetails?.user_device_id,
    selectedDeviceDetails?.device_type,
    isInHomDevice,
    userData?.isGuestUser,
    dispatch,
    history,
  ]);

  const scheduleNextDeviceStatusRefresh = useCallback(() => {
    if (deviceStatusTimeoutRef?.current) {
      clearTimeout(deviceStatusTimeoutRef?.current);
      deviceStatusTimeoutRef.current = null;
    }
    if (
      isInHomDevice ||
      !selectedDeviceDetails?.user_device_id ||
      selectedDeviceDetails?.device_type?.trim()?.toLowerCase() === "clairvoyant"
    ) {
      return;
    }
    
    const rawIntervalMinutes = deviceStatus?.refresh_interval ?? 
      appConfigurations?.device_connection_status_refresh_interval;
    
    const intervalMinutes = Number(rawIntervalMinutes);
    if (
      !rawIntervalMinutes ||
      Number.isNaN(intervalMinutes) ||
      intervalMinutes <= 0
    ) {
      return;
    }
    const timeoutMs = intervalMinutes * 60 * 1000;
    deviceStatusTimeoutRef.current = setTimeout(() => {
      fetchDeviceStatus();
    }, timeoutMs);
  }, [
    isInHomDevice,
    selectedDeviceDetails?.user_device_id,
    selectedDeviceDetails?.device_type,
    deviceStatus?.refresh_interval,
    appConfigurations?.device_connection_status_refresh_interval,
    fetchDeviceStatus,
  ]);

  scheduleNextDeviceStatusRefreshRef.current = scheduleNextDeviceStatusRefresh;

  useEffect(() => {
    if (
      deviceStatus &&
      deviceStatus?.userDeviceId === selectedDeviceDetails?.user_device_id &&
      !isInHomDevice &&
      selectedDeviceDetails?.device_type?.trim()?.toLowerCase() !== "clairvoyant"
    ) {
      scheduleNextDeviceStatusRefresh();
    }
  }, [deviceStatus, selectedDeviceDetails?.user_device_id, isInHomDevice, selectedDeviceDetails?.device_type, scheduleNextDeviceStatusRefresh]);

  useEffect(() => {
    if (deviceStatusTimeoutRef?.current) {
      clearTimeout(deviceStatusTimeoutRef?.current);
      deviceStatusTimeoutRef.current = null;
    }
    
    scheduleNextDeviceStatusRefresh();

    return () => {
      if (deviceStatusTimeoutRef?.current) {
        clearTimeout(deviceStatusTimeoutRef?.current);
        deviceStatusTimeoutRef.current = null;
      }
    };
  }, [
    selectedDeviceDetails?.user_device_id,
    isInHomDevice,
    deviceStatus?.refresh_interval,
    appConfigurations?.device_connection_status_refresh_interval,
    scheduleNextDeviceStatusRefresh,
  ]);

  useEffect(() => {
    if (deviceStatusTimeoutRef?.current) {
      clearTimeout(deviceStatusTimeoutRef?.current);
      deviceStatusTimeoutRef.current = null;
    }
    if (
      isInHomDevice ||
      !selectedDeviceDetails?.user_device_id ||
      selectedDeviceDetails?.device_type?.trim()?.toLowerCase() === "clairvoyant"
    ) {
      return;
    }
    const rawIntervalMinutes =
      deviceStatus?.device_connection_status_refresh_interval;
    const intervalMinutes = Number(rawIntervalMinutes);
    if (
      !rawIntervalMinutes ||
      Number.isNaN(intervalMinutes) ||
      intervalMinutes <= 0
    ) {
      return;
    }
    const timeoutMs = intervalMinutes * 60 * 1000;
    deviceStatusTimeoutRef.current = setTimeout(() => {
      fetchDeviceStatus();
    }, timeoutMs);
    return () => {
      if (deviceStatusTimeoutRef?.current) {
        clearTimeout(deviceStatusTimeoutRef?.current);
        deviceStatusTimeoutRef.current = null;
      }
    };
  }, [
    selectedDeviceDetails?.user_device_id,
    isInHomDevice,
    deviceStatus?.device_connection_status_refresh_interval,
  ]);

  useEffect(() => {
    if (!disableManualRefresh) return;
    const intervalId = setInterval(() => {
      setManualRefreshIntervalTime((prevTimer) => {
        if (prevTimer <= 0) {
          setDisableManualRefresh(false);
          if (intervalId) clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [disableManualRefresh]);

  useEffect(() => {
    if (prevDisableStateRef.current === true && disableManualRefresh === false) {
      const isStillInProgress = deviceDetails?.syncHistory?.syncStatus === SYNC_STATUS.IN_PROGRESS;
      
      if (!isInHomDevice && selectedDeviceDetails?.user_device_id && isStillInProgress) {
        setDeviceSyncLog(dispatch, {
          log: eventLogs?.fallback_trigger,
          loggedAt: moment()?.utc()?.toISOString(),
        });
        getDeviceProfileDetail(true);
      }
    }
    prevDisableStateRef.current = disableManualRefresh;
  }, [disableManualRefresh, isInHomDevice, selectedDeviceDetails?.user_device_id, deviceDetails?.syncHistory?.syncStatus]);

  useEffect(() => {
    if (
      prevIsSyncExpiredRef.current === false &&
      isSyncExpired === true
    ) {
      const isStillInProgress = deviceDetails?.syncHistory?.syncStatus === SYNC_STATUS.IN_PROGRESS;
      
      if (!isInHomDevice && selectedDeviceDetails?.user_device_id && isStillInProgress) {
        setDeviceSyncLog(dispatch, {
          log: eventLogs?.fallback_trigger,
          loggedAt: moment()?.utc()?.toISOString(),
        });
        getDeviceProfileDetail(true);
      }
    }
    prevIsSyncExpiredRef.current = isSyncExpired;
  }, [
    isSyncExpired,
    isInHomDevice,
    selectedDeviceDetails?.user_device_id,
    deviceDetails?.syncHistory?.syncStatus,
  ]);

  useEffect(() => {
    if (selectedDeviceDetails && deviceDetails) {
      animateMapToRegion();
    }
  }, [
    selectedDeviceDetails,
    deviceDetails?.deviceData?.locationData?.latitude,
    deviceDetails?.deviceData?.locationData?.longitude,
  ]);

  const cleanUpCall = () => {
    setDeviceDetailLoaderVisibility(dispatch, false);
    if (syncRef?.current) {
      callDeviceSynLogs({
        dispatch,
        history,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
        payload: {
          syncId: syncRef?.current,
          syncLogs: [
            ...deviceSyncLogsRef?.current,
            {
              log: eventLogs?.left_screen,
              loggedAt: moment()?.utc()?.toISOString(),
            },
          ],
        },
      });
    }
  };

  useEffect(() => {
    if (deviceDetails) {
      checkManualRefreshButtonAccess();
    }
  }, [deviceDetails]);

  useDeviceSocket((data) => {
    if (
      !isInHomDevice &&
      data?.userDeviceId === selectedDeviceDetails?.user_device_id
    ) {
      const payload = {
        dispatch,
        history,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
        userDeviceId: selectedDeviceDetails?.user_device_id,
        isAutoTriggered: true,
      };
      getDeviceDetails(payload);
      fetchDeviceStatus();
      callDeviceSynLogs({
        dispatch,
        history,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
        payload: {
          syncId: syncRef?.current,
          syncLogs: [
            ...deviceSyncLogsRef?.current,
            {
              log: eventLogs?.data_updated,
              loggedAt: moment()?.utc()?.toISOString(),
            },
          ],
        },
      });
    }
  });

  useEffect(() => {
    if (disableManualRefresh && deviceDetailLoading) {
      setDeviceDetailLoaderVisibility(dispatch, false);
    }
  }, [disableManualRefresh]);

  const onUserHelpGuide = async () => {
    try {
      const url = getStaticUrlByKey(staticUrls, "user_help_guide");
      await window.open(url, "_blank");
    } catch (e) {}
  };

  const checkManualRefreshButtonAccess = () => {
    (() => {
      if (!deviceDetails || !selectedDeviceDetails) return;

      const deviceType = selectedDeviceDetails?.device_type?.trim();
      if (!deviceType) return;

      const lastRequestedTime = getCalculatedLastRefreshTime(
        deviceDetails?.syncHistory?.syncRequestedOn,
        deviceDetails?.syncHistory?.syncCompletedOn
      );

      if (lastRequestedTime) {
        const manualRefreshTime = getManualRefreshTime(
          deviceType,
          aneltoIntervals,
          freeusIntervals,
          clairvoyantIntervals,
          eViewIntervalArray
        );
        const isDisable = isDisableManualRefresh(
          deviceDetails?.syncHistory?.syncCompletedOn,
          manualRefreshTime
        );
        setDisableManualRefresh(isDisable);
        if (isDisable || deviceDetails?.syncHistory?.isLastTwoFailed) {
          const diffInMin = getLastRefreshTimeInMinutes(
            deviceDetails?.syncHistory?.syncCompletedOn,
            true
          );
          setManualRefreshIntervalTime(manualRefreshTime * 60 - diffInMin);
        } else {
          setManualRefreshIntervalTime(0);
        }
      }
    })();
  };

  const getDeviceDetailManually = (isManual = false) => {
    setShowLocationModal(false);
    const params = {
      dispatch,
      userDeviceId: selectedDeviceDetails?.user_device_id,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      isManual: true,
    };
    callSycsDevideDetails(params);
  };

  const onRefresh = () => {
    if (!isInHomDevice) {
      getDeviceProfileDetail();
    }
  };

  const animateMapToRegion = () => {
    const formattedObj = customSchemaForUI();
    const latitude = formattedObj?.latitude
      ? parseFloat(formattedObj?.latitude)
      : 0;
    const longitude = formattedObj?.longitude
      ? parseFloat(formattedObj?.longitude)
      : 0;

    const regionLatlong = {
      ...deviceLocation,
      latitude: latitude,
      longitude: longitude,
    };
    setDeviceLocation(regionLatlong);
  };

  const getDeviceProfileDetail = (isAutoTriggered = false) => {
    const payload = {
      dispatch,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      userDeviceId: selectedDeviceDetails?.user_device_id,
      isAutoTriggered,
    };
    getDeviceDetails(payload);
  };

  const getConnectionStatusForCard = () => {
    if (
      !deviceStatus ||
      deviceStatus?.userDeviceId !== selectedDeviceDetails?.user_device_id
    ) {
      return undefined;
    }
    return deviceStatus?.isOnline ?? null;
  };

  const customSchemaForUI = () => {
    const featuresData = deviceDetails?.deviceData?.featuresData;
    const locationData = deviceDetails?.deviceData?.locationData;
    const statusData = deviceDetails?.deviceData?.statusData;
    const deviceInformation = deviceDetails?.deviceInfo;
    const syncHistory = deviceDetails?.syncHistory;

    const lastRequestedTime = getCalculatedLastRefreshTime(
      syncHistory?.syncRequestedOn,
      syncHistory?.syncCompletedOn
    );

    return {
      deviceName:
        deviceInformation?.deviceName || selectedDeviceDetails?.device_name,
      autoFallDetection: featuresData?.isFallDetect || false,
      deviceId:
        deviceInformation?.providerDeviceId ||
        selectedDeviceDetails?.provider_device_id,
      latitude: locationData?.latitude || 0,
      longitude: locationData?.longitude || 0,
      batteryLife: statusData?.battery ? statusData?.battery : "0",
      stepCounter: statusData?.steps ? statusData?.steps : "0",
      totalSteps:
        deviceInformation?.stepGoal || selectedDeviceDetails?.step_goal,
      locateMyDeviceId:
        deviceDetails?.device_sku ||
        selectedDeviceDetails?.provider_device_id ||
        "-",
      userDeviceId:
        deviceInformation?.userDeviceId ||
        selectedDeviceDetails?.user_device_id,
      medicalAlertUserId:
        deviceDetails?.medical_alert_user_id ||
        selectedDeviceDetails?.medical_alert_user_id,
      lastRefreshTime: syncHistory?.syncCompletedOn || lastRequestedTime,
      lastRequestedTime: syncHistory?.syncRequestedOn,
      dataTimeStamp: deviceDetails?.deviceData?.dataTimestamp,
      signal_strength: statusData?.signalStrength,
      loatName: deviceInformation?.lotName || selectedDeviceDetails?.lot_name,
      networkProvider: deviceDetails?.network_provider,
      locationTimeStamp: locationData?.locationTimestamp,
      featuresTimeStamp: featuresData?.featuresTimestamp,
      statusTimeStamp: statusData?.statusTimestamp,
      otherData: { ...deviceDetails },
    };
  };

  const onCaregavireTracking = () => {
    setDeviceDetailLoaderVisibility(dispatch, false);
    history?.push(ROUTES_CONSTANTS.caregiverTracking, {
      isButtonDisable: disableManualRefresh,
    });
  };

  const onLocationHistory = () => {
    setDeviceDetailLoaderVisibility(dispatch, false);
    history?.push(ROUTES_CONSTANTS.location, {
      isButtonDisable: disableManualRefresh,
    });
  };

  const onTapToRing = () => {
    ringMyDevice(
      dispatch,
      {
        user_device_id: selectedDeviceDetails?.user_device_id,
        medical_alert_user_id: selectedDeviceDetails?.medical_alert_user_id,
        providerDeviceId: selectedDeviceDetails?.provider_device_id,
      },
      onApiResponse,
      setShowRingDeviceModal,
      selectedDeviceDetails?.device_type,
      userData?.isGuestUser ? "guestuser" : "accountowner",
      history
    );
  };

  const onManualRefreshClick = () => {
    if (manualRefreshLoading) {
      return;
    } else if (disableManualRefresh) {
      return;
    } else {
      getDeviceDetailManually(true);
      setTimeout(() => {
        setShowLocationModal(true);
      }, 500);
    }
  };

  const convertInLocalTimeZone = (date) => {
    return convertInRequiredTimeZone(
      date,
      selectedMedicalUser?.timezone,
      currentTimeZone
    );
  };

  const connectionStatus = getConnectionStatusForCard();

  return (
    <MainLayout
      text={titles?.device_profile}
      isBackHide={false}
      isSemiHeader={true}
      white={true}
      primary={true}
      loading={loading}
    >
      {snackbarState?.show && (
        <div className="snackbar_sticky">
          <MessageSnackBar
            message={snackbarState?.message}
            isVisible={true}
            type={snackbarState?.type}
            autoHideDuration={snackbarState?.autoHideDuration}
            onDismiss={dismissSnackbar}
          />
        </div>
      )}

      {deviceDetailLoading ? (
        <div className="gif_loader_container">
          <img height="50px" width="50px" src={loader_gif} alt="loader" />
        </div>
      ) : null}
      <div className="dp_container">
        <RingDeviceModal
          setShow={setShowRingDeviceModal}
          show={showRingDeviceModal}
          selectedDeviceDetails={selectedDeviceDetails}
          onClick={onTapToRing}
        />
        <DeviceInfoModal
          selectedDeviceDetails={selectedDeviceDetails}
          deviceSchema={customSchemaForUI()}
          setShow={setShowDeviceInfo}
          show={showDeviceInfo}
        />
        <EditDeviceNameModal
          setShow={setShowEditDeviceModal}
          show={showEditDeviceModal}
          onCancel={() => setShowEditDeviceModal(false)}
        />
        <AddStepGoalModal
          show={showAddStepGoalModal}
          setShow={setShowAddStepGoalModal}
          currentGoal={customSchemaForUI()?.totalSteps}
        />
        <ConfirmationModal
          show={showLocationModal}
          setShow={setShowLocationModal}
          svgIcon={<IconTracking />}
          btnText={titles?.OK}
          title={titles?.location_signal}
          description={titles?.location_signal_desc}
          onClick={() => setShowLocationModal(false)}
        />
        <ChangesSavedModal
          show={showSavedSuccessModal}
          setShow={setShowSavedSuccessModal}
        />
        <InformationModal
          show={informationModal}
          setShow={setInformationModal}
          infoText={titles?.modal_texts?.device_profile_footer_help_tip}
        />
        <FrequentRequestPopup
          show={frequentRequestPopup?.isVisible}
          setShow={setFrequentRequestPopup}
          lastRefreshTime={frequentRequestPopup?.lastRefreshTime}
          deviceType={selectedDeviceDetails?.device_type?.trim()}
        />

        <div className="dp_device_card">
          <div className="dp_device_sub_container">
            <div className="dp_device_image_container">
              {selectedDeviceDetails?.image_url ? (
                <img
                  src={selectedDeviceDetails?.image_url}
                  alt="Device"
                  className="dp_device_image"
                />
              ) : (
                <div className="dp_device_placeholder">
                  <IconGPSDevice width="32" height="32" />
                </div>
              )}
              {!isInHomDevice &&
                selectedDeviceDetails?.device_type !== "clairvoyant" &&
                connectionStatus !== undefined && (
                  <div
                    className={`dp_connection_status_indicator ${
                      connectionStatus === true
                        ? "dp_connection_status_online_indicator"
                        : connectionStatus === false
                        ? "dp_connection_status_offline_indicator"
                        : "dp_connection_status_unknown_indicator"
                    }`}
                  />
                )}
            </div>
            <div className="dp_device_description_container">
              <h2 className="dp_device_title">
                {customSchemaForUI()?.deviceName}
              </h2>
              <p className="dp_device_subtitle">
                {`${selectedDeviceDetails?.firstname} ${selectedDeviceDetails?.lastname}`}
              </p>
              {!isInHomDevice &&
                selectedDeviceDetails?.device_type !== "clairvoyant" &&
                connectionStatus !== undefined && (
                  <div className="dp_connection_status">
                    <span className="dp_connection_status_label">
                      {titles?.connection_status}{" "}
                    </span>
                    <span
                      className={`dp_connection_status_value ${
                        connectionStatus === true
                          ? "dp_connection_status_online"
                          : connectionStatus === false
                          ? "dp_connection_status_offline"
                          : "dp_connection_status_unknown"
                      }`}
                    >
                      {connectionStatus === true
                        ? titles?.online
                        : connectionStatus === false
                        ? titles?.offline
                        : titles?.unknown}
                    </span>
                  </div>
                )}
              <button
                className="dp_about_device_link"
                onClick={() => setShowDeviceInfo(true)}
              >
                {titles?.about_this_device}
              </button>
            </div>
            <div className="dp_edit_button_container">
              <IconEdit
                className="dp_edit_icon"
                color="#6B6B6B"
                onClick={() => setShowEditDeviceModal(true)}
              />
            </div>
          </div>

          {!isInHomDevice && (
            <>
              <CustomButton
                text={buttonText}
                width="100%"
                className="dp_refresh_button"
                isGrayButton={
                  disableManualRefresh || manualRefreshLoading || isSyncing
                }
                disabled={
                  isSyncing || disableManualRefresh || manualRefreshLoading
                }
                isLoading={isSyncing || manualRefreshLoading}
                onClick={() => onManualRefreshClick()}
              />

              {convertInLocalTimeZone(customSchemaForUI()?.lastRefreshTime) && (
                <div className="dp_last_refresh_container">
                  <p className="dp_last_refresh_text">
                    {`${titles?.last_refresh} ${convertInLocalTimeZone(
                      customSchemaForUI()?.lastRefreshTime
                    )}`}
                  </p>
                  <IconQuestion
                    className="dp_help_icon"
                    width={"16px"}
                    height={"16px"}
                    onClick={() => setInformationModal(true)}
                  />
                </div>
              )}

              {!manualRefreshLoading && disableManualRefresh && (
                <p className="dp_refresh_warning">
                  {manualRefreshIntervalTime > 0
                    ? `Frequent requests can drain battery. You can refresh again in ${manualRefreshIntervalTime} seconds.`
                    : ""}
                </p>
              )}
            </>
          )}
        </div>

        {!isInHomDevice && (
          <>
            <CaregiverTrackingCard
              deviceLocation={deviceLocation}
              customSchemaForUI={()=>customSchemaForUI()}
              onCaregavireTracking={onCaregavireTracking}
              onLocationHistory={onLocationHistory}
              selectedDeviceDetails={selectedDeviceDetails}
              selectedMedicalUser={selectedMedicalUser}
              currentTimeZone={currentTimeZone}
            />

            <DeviceSignalCard
              type={selectedDeviceDetails?.device_type}
              deviceInfo={customSchemaForUI()}
              statusUpdateAt={
                customSchemaForUI()?.statusTimeStamp
                  ? `${
                      titles?.device_status_information
                    } ${convertInLocalTimeZone(
                      customSchemaForUI()?.statusTimeStamp
                    )}`
                  : ""
              }
              className="dp_battery_signal_card"
            />

            {selectedDeviceDetails?.device_type === "anelto" ||
            selectedDeviceDetails?.device_type === "eview" ? null : (
              <StepCounterCard
                customSchemaForUI={customSchemaForUI}
                setShowAddStepGoalModal={setShowAddStepGoalModal}
                selectedMedicalUser={selectedMedicalUser}
                currentTimeZone={currentTimeZone}
              />
            )}

            <div className="dp_locate_device_card">
              <div className="dp_locate_header">
                <div className="dp_locate_info">
                  <h4 className="dp_step_title">{titles?.locate}</h4>
                  <p className="dp_step_status_time">
                    {customSchemaForUI()?.loatName}
                  </p>
                </div>
                <CustomButton
                  text={titles?.ring_device}
                  className="dp_ring_device_button"
                  width={"128px"}
                  onClick={() => setShowRingDeviceModal(true)}
                />
              </div>
            </div>
          </>
        )}
        <div className="dp_more_options">
          <h3 className="dp_more_options_title">{titles?.more_options}</h3>
          <div className="dp_options_list">
            {accordianButtons?.map((data, index) => (
              <div
                key={`option-${index}`}
                className="dp_option_item"
                onClick={() => {
                  setDeviceDetailLoaderVisibility(dispatch, false);
                  data?.onClick();
                }}
              >
                <span className="dp_option_text">{data?.name}</span>
                <ArrowRight width="24" height="24" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DeviceProfile;
